import React, { useEffect, useState, useCallback } from 'react';
import { Form, Input, Button, Row, Col, Select, DatePicker,message, Space } from 'antd';
import moment from 'moment';

import SPVehicleCascader from '../SPVehicleCascader';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

import emiter, {
  EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH,
  EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_MODE_TYPE,
  EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH
} from '../../../../events'

import request from '../../../../request';
import { API_STORE_LIST_SELECT } from '../../../../hooks/carRental/_';
import {DEFAULT_PAGE_INFO} from "../../../../consts";
import {DEFAULT_DAY, ModeType, ModeTypeSetObj} from "../SPOccupyCalendarNew/const";

interface PropsType {
	enums?: any;
}

const SPVehicleCalendarSearchForm: React.FC<PropsType> = props => {
	const { enums } = props;
  const [modeType, setModeType] = useState<any>(ModeType.DAY)
  const [isfold, setIsFold] = useState<boolean>(false)

	const [storeListOptions, setStoreListOptions] = useState<any>([]);

	const searchFormFields = {
		mendian: {
			name: 'store_code',
			label: '门店',
			required: true,
			message: '请选择门店',
			placeholder: '请输入',
		},
		chepaihao: {
			name: 'veh_plate',
			label: '车牌号',
			required: false,
			message: '请输入车牌号',
			placeholder: '请输入',
		},
		riqi: {
			name: 'date',
			label: '日期',
			required: false,
			message: '请选择日期',
			placeholder: '请选择',
			extra: '*默认查询一个月'
		},
	};

	const [searchForm] = Form.useForm();
	const [isShow, setIsShow] = useState(false);

	const getStoreList = () => {
		return request({
			url: API_STORE_LIST_SELECT,
			method: 'GET',
		}).then((res: any) => {
			if (!res.data || !res.data.length) {
				setStoreListOptions([]);
				searchForm.setFieldValue(searchFormFields.mendian.name, undefined);
				return;
			}
			setStoreListOptions(res.data);
			searchForm.setFieldValue(searchFormFields.mendian.name, res.data[0].store_code);
			setIsShow(true);
		}).catch(err => {
			message.error(err.message || '查询门店列表失败');
		});
	}


	const onSearchFormFinish = () => {
		emiter.emit(EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH,{
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	 };

	const clearSearch = () => {
		searchForm.resetFields([searchFormFields.chepaihao.name, 'vehicle_id', searchFormFields.riqi.name]);
		emiter.emit(EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH,{
      ...searchForm.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
	};

  const onModeType = (e: any) => {
    setModeType(e)
  }


	useEffect(() => {
		getStoreList();
		emiter.on(EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH, onSearchFormFinish);
		emiter.on(EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_MODE_TYPE, onModeType);
		return () => {
			emiter.removeAllListeners(EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH)
		}
	}, []);


	return (
		<>
			{isShow ?
				<Form form={searchForm} size='middle' onFinish={onSearchFormFinish}>
			<Row gutter={24}>
				<Col span={8}>
					<Form.Item
						name={searchFormFields.mendian.name}
						label={searchFormFields.mendian.label}
						rules={[
							{
								required: searchFormFields.mendian.required,
								message: searchFormFields.mendian.message,
							},
						]}
					>
						<Select options={storeListOptions} fieldNames={{label:'store_name', value:'store_code'}}></Select>
					</Form.Item>
				</Col>
				<Col span={8}>
					<SPVehicleCascader isRequired={false}></SPVehicleCascader>
				</Col>
        <Col span={8}>
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Space>
              <Button onClick={() => {
                setIsFold(!isfold)
              }} type='link' icon={ isfold ? <DownOutlined/> : <UpOutlined /> }>{
                isfold ? '更多' : '收起'
              }</Button>
              <Button type="primary" onClick={onSearchFormFinish}>
                查询
              </Button>
              <Button onClick={clearSearch}>清空</Button>
            </Space>
          </div>
        </Col>
      </Row>
          {
            !isfold && <Row gutter={24}>
                  <Col  span={8}>
                      <Form.Item
                          name={searchFormFields.chepaihao.name}
                          label={searchFormFields.chepaihao.label}
                          rules={[
                            {
                              required: searchFormFields.chepaihao.required,
                              message: searchFormFields.chepaihao.message,
                            },
                          ]}
                      >
                          <Input placeholder={searchFormFields.chepaihao.placeholder}/>
                      </Form.Item>
                  </Col>
                  <Col span={8}>
                      <Form.Item
                          initialValue={[moment().startOf('day'), moment().add(DEFAULT_DAY, 'days').endOf('day')]}
                          name={searchFormFields.riqi.name}
                          label={searchFormFields.riqi.label}
                          rules={[
                            {
                              required: searchFormFields.riqi.required,
                              message: searchFormFields.riqi.message,
                            },
                          ]}
                      >
                          <DatePicker.RangePicker
                              allowClear={false}
                              style={{ width: '100%' }}></DatePicker.RangePicker>
                      </Form.Item>
                  </Col>
                  <Col span={8} style={{ marginLeft: '18px' }}></Col>
              </Row>
          }
		</Form>:null
				}
		</>
	);
};

export default SPVehicleCalendarSearchForm;
